import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-doc-achat',
  templateUrl: './doc-achat.component.html',
  styleUrls: ['./doc-achat.component.scss']
})
export class DocAchatComponent implements OnInit {

  constructor(private router : Router) { }

  ngOnInit(): void {
  }


  retour() {
    this.router.navigate(['/main/parametre/document']);
  }
}
